import {Component, EventEmitter, Input, OnInit, Output, NgZone} from '@angular/core';

@Component({
    selector: 'app-search-personal-mode',
    templateUrl: './search-personal-mode.component.html',
    styleUrls: ['./search-personal-mode.component.scss'],
})
export class SearchPersonalMode implements OnInit {
    @Input() active: any;
    @Input() search: any;
    @Output() changed = new EventEmitter<any>();
    @Output() searching = new EventEmitter<any>();
    @Output() searchbarShowHide = new EventEmitter<any>();
    searchBarShow = false;

    constructor(
        public ngZone: NgZone
    ) {
    }

    ngOnInit() {
    }

    onChanged(event) {
        this.changed.emit(event.detail.value);
    }

    showSearchBar() {
        this.ngZone.run(() => {
            this.searchBarShow = !this.searchBarShow;
            this.searchbarShowHide.emit(this.searchBarShow);
        });
    }
}
